// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentPreview_wrapper__6JcIM","hist":"DocumentPreview_hist__7I9vT"};